// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summer{background-color:#a69667}.text-summer{color:#a69667}", ""]);
// Exports
module.exports = exports;
